import { Button, ButtonGroup } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';

// ======================================================= //

export default function Period({period, index, day, handleEdit}) {

    // ------------------------------------------------------- //

    return (
        <React.Fragment>
            <ButtonGroup
                size='small'
                variant='contained'
                color={index%2 === 0 ? 'primary' : 'secondary'}
            >
                <Button>
                    <a href={period.link} target="_blank" rel="noreferrer" style={{color: 'white', textDecoration: 'none'}}>{period.name}</a>
                </Button>
                <Button onClick={() => handleEdit(day, index)}>
                    <EditIcon sx={{fontSize: "1em", color: "white"}}/>
                </Button>
            </ButtonGroup>
        </React.Fragment>
    )
}